import { type ChangeEvent, type FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { spokenFieldHint } from '@eneco/components/spoken-field/spoken-field';
import { TrackedDialog } from '@eneco/components/TrackedDialog/TrackedDialog';
import { Box, Heading, InputText, Stack, Text, TextLink } from '@eneco/sparky';
import { friendlyFormatIBAN } from 'ibantools';
import type { FieldError, UseFormRegister } from 'react-hook-form';

import type { SummaryPaymentDetailsTextualData } from './summary-step.types';

interface Props {
  textualData?: SummaryPaymentDetailsTextualData;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>;
  ibanError?: FieldError;
}

const formatIbanOnChange = (event: ChangeEvent<HTMLInputElement>) => {
  const target = event.target;
  const caretPosition = target.selectionStart;
  const currentValue = target.value;
  const newValue = friendlyFormatIBAN(currentValue) ?? '';

  target.value = newValue;
  target.selectionEnd = currentValue.length !== newValue.length ? (caretPosition ?? 0) + 1 : caretPosition;
};

export const SummaryPaymentDetails: FC<Props> = ({ textualData, register, ibanError }) => (
  <>
    <Stack.Item>
      <Stack direction="column" gap="4">
        <Heading as="h3" size="XS">
          {textualData?.title?.value}
        </Heading>
        <Text>{textualData?.description?.value}</Text>
      </Stack>
    </Stack.Item>

    <Stack.Item>
      <InputText
        {...register('iban', { onChange: formatIbanOnChange })}
        label={textualData?.ibanFormField?.value?.label ?? ''}
        hint={spokenFieldHint(textualData?.ibanFormField?.value?.hint, textualData?.ibanFormField?.value?.placeholder)}
        error={ibanError?.message}
      />

      <Box paddingTop="3">
        <Text size="BodyS" color="textLowEmphasis">
          <TrackedDialog
            title={textualData?.ibanDialog?.value?.title}
            trigger={<TextLink>{textualData?.ibanDialog?.value?.triggerText}</TextLink>}>
            <RichText html={textualData?.ibanDialog?.value?.content} />
          </TrackedDialog>
        </Text>
      </Box>
    </Stack.Item>
  </>
);
